export const plummerBlocks = [
    {
        dia: 3.0,
        model: 'SN507',
        bearing: '',
        dynamicRating: '',
        weight: 3.0,
    },
    {
        dia: 3.5,
        model: 'SN508',
        bearing: '22208K',
        dynamicRating: 88,          // kN
        weight: 3.9,                // kg
    },
    {
        dia: 4.0,
        model: 'SN509',
        bearing: '22209K',
        dynamicRating: 93,
        weight: 4.0,
    },
    {
        dia: 4.5,
        model: 'SN510',
        bearing: '22210K',
        dynamicRating: 98,
        weight: 5.0,
    },
    {
        dia: 5.0,
        model: 'SN511',
        bearing: '22211K',
        dynamicRating: 120,
        weight: 6.0,
    },
    {
        dia: 5.5,
        model: 'SN512',
        bearing: '22212K',
        dynamicRating: 143,
        weight: 6.8,
    },
    {
        dia: 6.0,
        model: 'SN513',
        bearing: '22213K',
        dynamicRating: 173,
        weight: 7.8,
    },
    {
        dia: 6.5,
        model: 'SN515',
        bearing: '22215K',
        dynamicRating: 183,
        weight: 8.0,
    },
    {
        dia: 7.0,
        model: 'SN516',
        bearing: '22216K',
        dynamicRating: 212,
        weight: 12.0,
    },
    {
        dia: 7.5,
        model: 'SN517',
        bearing: '22217K',
        dynamicRating: 260,
        weight: 13.0,
    },
    {
        dia: 8.0,
        model: 'SN518',
        bearing: '22218K',
        dynamicRating: 285,
        weight: 18.0,
    },
    {
        dia: 8.5,
        model: 'SN519',
        bearing: '22219K',
        dynamicRating: 315,
        weight: 20.0,
    },
    {
        dia: 9.0,
        model: 'SN520',
        bearing: '22220K',
        dynamicRating: 360,
        weight: 22.0,
    },
    {
        dia: 10.0,
        model: 'SN522',
        bearing: '22222K',
        dynamicRating: 455,
        weight: 28.0,
    },
    {
        dia: 11.0,
        model: 'SN524',
        bearing: '22224K',
        dynamicRating: 540,
        weight: 31.0,
    },
    {
        dia: 11.5,
        model: 'SN526',
        bearing: '22226K',
        dynamicRating: 630,
        weight: 42.0,
    },
    {
        dia: 12.5,
        model: 'SN528',
        bearing: '22228K',
        dynamicRating: 735,
        weight: 56.0,
    },
    {
        dia: 13.5,
        model: 'SN530',
        bearing: '22228K',
        dynamicRating: 850,
        weight: 61.0,
    },
    {
        dia: 14.0,
        model: 'SN532',
        bearing: '22232K',
        dynamicRating: 965,
        weight: 68.0,
    },
    {
        dia: 15.0,
        model: 'SD3134',
        bearing: '23134K',
        dynamicRating: 1020,
        weight: 95.0,
    },
    {
        dia: 16.0,
        model: 'SD3136',
        bearing: '23136K',
        dynamicRating: 1200,
        weight: 110.0,
    },
    {
        dia: 17.0,
        model: 'SD3138',
        bearing: '23138K',
        dynamicRating: 1340,
        weight: 130.0,
    },
    {
        dia: 18.0,
        model: 'SD3140',
        bearing: '23140K',
        dynamicRating: 1320,        // 앞 보다 작다. ??
        weight: 180.0,
    },
    {
        dia: 20.0,
        model: 'SD3144',
        bearing: '23144K',
        dynamicRating: 1630,
        weight: 230.0,
    },
    {
        dia: 22.0,
        model: 'SD3148',
        bearing: '23148K',
        dynamicRating: 1860,
        weight: 270.0,
    },
    {
        dia: 24.0,
        model: 'SD3152',
        bearing: '23152K',
        dynamicRating: 2200,
        weight: 300.0,
    },
    {
        dia: 26.0,
        model: 'SD3156',
        bearing: '23156K',
        dynamicRating: 2360,
        weight: 370.0,
    },
    {
        dia: 28.0,
        model: 'SD3160',
        bearing: '23160K',
        dynamicRating: 2650,
        weight: 470.0,
    },
    {
        dia: 30.0,
        model: 'SD3164',
        bearing: '23164K',
        dynamicRating: 3200,
        weight: 590.0,
    },
    {
        dia: 34.0,
        model: 'SD3172',
        bearing: '23172K',
        dynamicRating: 3800,
        weight: 760.0,
    },
    {
        dia: 36.0,
        model: 'SD3176',
        bearing: '23176K',
        dynamicRating: 4050,
        weight: 1000.0,
    },
    {
        dia: 38.0,
        model: 'SD3180',
        bearing: '23180K',
        dynamicRating: 4250,
        weight: 1100.0,
    },
    {
        dia: 40.0,
        model: 'SD3184',
        bearing: '23184K',
        dynamicRating: 5000,
        weight: 1200.0,
    },
];


